import { render, staticRenderFns } from "./convinboss.vue?vue&type=template&id=342af0d5&scoped=true&"
import script from "./convinboss.vue?vue&type=script&lang=js&"
export * from "./convinboss.vue?vue&type=script&lang=js&"
import style0 from "./convinboss.vue?vue&type=style&index=0&id=342af0d5&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342af0d5",
  null
  
)

export default component.exports